import { PostTradesApi } from "@/features/accounts/ocr/services/post-trades-api";
import { PostTradesRequestModel } from "@/features/accounts/ocr/services/post-trades-model";

/// OCR読み取り結果処理
export class PostTradesService {
  private postTradesApi = new PostTradesApi();
  /**
   * OCR読み取り結果API実行
   */
  public async PostTrades(param: PostTradesRequestModel) {
    return await this.postTradesApi.PostTrades(param);
  }
}
